export const profileTransportu = [
  0.05, 0.05, 0.05, 0.05, 0.05, 0.05, 0.05, 0.04, 0.04, 0.04, 0.03, 0.02, 0.02, 0.02, 0.02, 0.03, 0.04, 0.05, 0.05,
  0.05, 0.05, 0.05, 0.05, 0.05,
];
